import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("同步资产回单")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确定")

import { ref, reactive } from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import Api from '@/http/modules/index'
import { epPropKey } from 'element-plus/es/utils'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  emits: ['syncSuccess'],
  setup(__props, { emit: emits }) {

let {
  'GET/financial_flows/drop_list/sync_financial_bank': sync_financial_bankApi,
  // 同步财资回单
  'POST/financial_flows/manual_financial_receipt': manual_financial_receiptApi,
} = Api


let { MI_modifyForm } = new tbMix(() => Promise.resolve())

const accoundEle = ref()
let assetsList = ref<{label: string, id: string}[]>([])
sync_financial_bankApi().then(({asset}) => {
  assetsList.value = asset.map((bank) => (
    {
      label: bank.accountNumber + '-' + bank.accountId,
      id: bank.accountId
    }
  ))
})

const showAssetsFg = ref<boolean>(false)
const isBanId = ref<boolean>(false)
let assetsObj = reactive({
  isSyncAll: false,
  accountId: '',
  syncDate: [],
})
const rules = reactive({
  isSyncAll: [{ required: true, message: '必选项', trigger: 'change' },],
  syncDate: [{ required: true, message: '请选择日期', trigger: 'change' },]
})
    

const showAssets = () => {
  // MI_modifyForm({}, assetsConfig, showAssetsFg)
  showAssetsFg.value = true
}

const syncChange = (val: boolean) => {
  if(val) {
    // 同步全部回单
    assetsObj.accountId = ''
    isBanId.value = true
  } else {
    isBanId.value = false
  }

}

const isBtnLd = ref<boolean>(false)
const submitHandle = () => {
  accoundEle.value.validate((valid: boolean) => {
    if (!valid) {
      console.log('error submit!')
      return
    }
    if(assetsObj.isSyncAll === false && !assetsObj.accountId){
      ElMessage.warning('请选择账号ID')
      return
    }
    isBtnLd.value = true
    manual_financial_receiptApi({
      ...assetsObj,
      syncDate: {
        from: assetsObj.syncDate[0],
        to: assetsObj.syncDate[1],
      }
    }).then(() => {
        ElMessage.success('成功')
        emits('syncSuccess')
      }).finally(() => {
        isBtnLd.value = false
      })
    })
}



return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("span", null, [
    _createVNode(_component_el_button, { onClick: showAssets }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "同步资产回单",
      modelValue: showAssetsFg.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((showAssetsFg).value = $event))
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          loading: isBtnLd.value,
          type: "primary",
          onClick: submitHandle
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          disabled: isBtnLd.value,
          "label-position": "left",
          model: _unref(assetsObj),
          inline: true,
          ref_key: "accoundEle",
          ref: accoundEle,
          "label-width": "100",
          rules: _unref(rules)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "全部同步",
              prop: "isSyncAll"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "form-input",
                  modelValue: _unref(assetsObj).isSyncAll,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(assetsObj).isSyncAll) = $event)),
                  placeholder: "请选择是否全部同步",
                  onChange: syncChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "全部同步",
                      value: true
                    }),
                    _createVNode(_component_el_option, {
                      label: "单个同步",
                      value: false
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "账号ID",
              prop: "accountId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "form-input",
                  filterable: "",
                  modelValue: _unref(assetsObj).accountId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(assetsObj).accountId) = $event)),
                  placeholder: "请选择账号ID",
                  clearable: "",
                  disabled: isBanId.value
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(assetsList), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: item.id,
                        key: item.label
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "日期",
              prop: "syncDate"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  type: "daterange",
                  modelValue: _unref(assetsObj).syncDate,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(assetsObj).syncDate) = $event)),
                  "value-format": "YYYY-MM-DD",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  placeholder: "请选择日期"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["disabled", "model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})